interface PresignedPost {
    url: string;
    fields: {
        [key: string]: string;
    };
}

type UploadSuccessCallback = (url: string) => void;
type UploadErrorCallback = (error: string) => void;
type SetUploadProgress = (progress: number) => void;

export type PresignedUploadResponse = {
    url: string;
    presignedPost: PresignedPost;
}


export const uploadFileToS3 = (
    presignedPost: PresignedPost,
    file: File,
    setUploadProgress: SetUploadProgress,
    onSuccess: UploadSuccessCallback,
    onError: UploadErrorCallback
): void => {
    const formData = new FormData();

    Object.keys(presignedPost.fields).forEach(key => {
        formData.append(key, presignedPost.fields[key]);
    });
    formData.append('file', file);

    const xhr = new XMLHttpRequest();
    xhr.open('POST', presignedPost.url, true);
    xhr.upload.onprogress = (e: ProgressEvent) => {
        if (e.lengthComputable) {
            const progress = (e.loaded / e.total) * 100;
            setUploadProgress(progress);
        }
    };

    xhr.onload = () => {
        if (xhr.status === 204 || xhr.status === 200) {
            onSuccess(presignedPost.url);
        } else {
            onError('Upload to S3 failed');
        }
    };

    xhr.onerror = () => {
        onError('An error occurred during the upload');
    };

    xhr.send(formData);
};
